import { ColumnType } from 'src/components/molecules';

export const labelExtractor = (tableCol: ColumnType) => tableCol.label;

export const getColumnNames = (columns: ColumnType[]) =>
  columns.map(labelExtractor);
